
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/organization-join",
      function () {
        return require("private-next-pages/organization-join/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/organization-join"])
      });
    }
  